import unitsJson from "./tables/infinite-war/units.json";
import cardsJson from "./tables/infinite-war/cards.json";
import viewJson from "./tables/presentation/infinite-war-view.json";

export type IwUnitsTable = typeof unitsJson;
export type IwCardsTable = typeof cardsJson;
export type IwViewTable = typeof viewJson;

export const infiniteWarCatalog = {
  units: unitsJson as IwUnitsTable,
  cards: cardsJson as IwCardsTable,
  view: viewJson as IwViewTable,
} as const;

export function hexToColor(hex: string): number {
  const s = hex.replace("#", "").slice(0, 6);
  return Number.parseInt(s, 16);
}
